/**
 * L'écran de connexion, tel que la maquette le dessine.
 *
 * **Deux colonnes, non une carte centrée.** La référence pose le formulaire sur
 * fond blanc à gauche et une surface sombre à droite, quadrillée, qui porte la
 * promesse du produit. Une carte centrée était une approximation ; elle ne
 * disait pas la même chose.
 *
 * **Il ne demande rien.** Pas de champ, pas de mot de passe : l'identité vient
 * d'Entra, et la seule chose que cette page fait est d'envoyer le navigateur
 * chez Microsoft. Le retour est traité par le portail, qui pose un cookie
 * `HttpOnly` — d'où l'absence totale de jeton dans ce code.
 *
 * `window.location.assign` plutôt que `fetch` : c'est une **navigation**, pas
 * un appel. Passer par `fetch` recevrait la redirection et ne saurait qu'en
 * faire.
 */
export function Connexion({ motif }: { motif?: string }) {
  const destination =
    window.location.pathname === "/connexion" ? "/" : window.location.pathname;

  return (
    <div className="portail-connexion">
      <div className="portail-connexion__formulaire">
        <div className="marque">
          <span className="marque__jeton" aria-hidden="true">
            M
          </span>
          <span className="marque__nom">
            Métré<span>Ops</span>
          </span>
        </div>

        <h1 className="portail-connexion__titre">Connexion</h1>
        <p className="portail-connexion__propos">
          Accès réservé aux collaborateurs autorisés. L'authentification est
          déléguée à votre annuaire Microsoft Entra ID.
        </p>

        {motif && <div className="avis avis--attention avis--etroit">{motif}</div>}

        <button
          type="button"
          className="bouton bouton--primaire bouton--microsoft"
          onClick={() =>
            // **`suite`, non `redirect_to`.** La route nomme son paramètre
            // ainsi ; l'autre nom était ignoré en silence, et l'on revenait
            // toujours à l'accueil après s'être authentifié depuis un lien
            // profond. Le portail n'accepte qu'un chemin de chez lui — voir
            // `web/auth/retours.py`.
            window.location.assign(
              `/auth/login?suite=${encodeURIComponent(destination)}`,
            )
          }
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="3" y="3" width="8" height="8" />
            <rect x="13" y="3" width="8" height="8" opacity=".75" />
            <rect x="3" y="13" width="8" height="8" opacity=".75" />
            <rect x="13" y="13" width="8" height="8" opacity=".55" />
          </svg>
          Se connecter avec Microsoft
        </button>

        <p className="portail-connexion__note">
          Votre compte professionnel, par Microsoft Entra ID. Aucun mot de passe
          n'est conservé par la plateforme.
        </p>
      </div>

      <div className="portail-connexion__panneau" aria-hidden="true">
        <div className="portail-connexion__grille" />
        <div className="portail-connexion__promesse">
          <div className="portail-connexion__surtitre">
            Économie de la construction
          </div>
          <p>
            Du DCE au métré chiffré : un espace de travail unique pour les
            pièces écrites, les plans et les quantités.
          </p>
        </div>
      </div>
    </div>
  );
}
